import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';

import { ROOT } from 'constants/routeConstants';
import useCosmosTrackEvent from 'hooks/useCosmosTrackEvent';
import Button from 'shared/components/Button/Button';
import { Store } from 'types/store';

import checkCircle from './assets/svg/check-circle-fill.svg';

const RenewalConfirmation = () => {
  const { isAppView } = useSelector((state: Store) => state?.content?.flags);
  const { custInfo } = useSelector((state: Store) => state.customer);

  const navigate = useNavigate();

  const { cosmosTrackEvent } = useCosmosTrackEvent('ExpiryRenewals');

  useEffect(() => {
    // Send monthly active user data to cosmos db
    cosmosTrackEvent('renewal_journey_complete');
    if (isAppView) {
      // App event on load
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ eventName: 'RENEWAL_COMPLETED' }));
      }
    }
  }, []);

  useEffect(() => {
    if (isAppView) return undefined;
    // Redirect to home on browser back rather than returning to the renewal journey
    const handlePopState = () => {
      navigate(ROOT, { replace: true });
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [isAppView, navigate]);

  const endJourney = () => {
    if (isAppView) {
      // App event on exit
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ eventName: 'RENEWAL_COMPLETED_CLOSE' }));
        // TODO: Workaround applied to support older versions until app is ready to fully use the above event
        window.ReactNativeWebView.postMessage(JSON.stringify({ eventName: 'ORANGE_POINTS_REDEEMED_CLOSE' }));
      }
    } else {
      // Redirect back to homepage
      navigate(ROOT, { replace: true });
    }
  }

  return (
    <div className="p-3">
      <Container className="bg-white p-4">
        <Row>
          <Col md={6} xs={12} className="text-center mx-auto">
            <img src={checkCircle} alt="check" className="py-3" />
            <h2 className="lh-1 py-3">
              <span className="orange">Thanks {custInfo?.Forename}</span> -<br />you’re all set
            </h2>
            <div className="vstack gap-3">
              <p>Your renewal email is on its way. If it’s not in your inbox, please check your spam folder. If you usually receive your documents by post, we’ll send you a paper copy. Your updated policy schedule will appear in myRAC within 5 working days.</p>
              <Button
                onClickHandler={endJourney}
                buttonText="Home"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default RenewalConfirmation;
